import * as prismic from '@prismicio/client'
import { PRISMIC_ENDPOINT } from './env'

const apiEndpoint = PRISMIC_ENDPOINT ?? ''

const prismicClient = prismic.createClient(apiEndpoint)

export { prismicClient }
